import {defineStore} from 'pinia'

export const useApiStore = defineStore('api', {
  state: () => ({
    crsf: '',
  }),
  getters: {
    async getCrsf(state) {
      // Fetch new CSRF token
      const response = await fetch('/session/token', {
        credentials: "include"
      })
      state.crsf = await response.text();
      return state.crsf;
    },

  },
})
